export const GET_ORDERS_PLANNINGS_LIST = 'orders-plannings/GET_ORDERS_PLANNINGS_LIST';
export const getOrdersPlanningsListAction = payload => ({
	type: GET_ORDERS_PLANNINGS_LIST,
	payload,
});

export const SET_ORDERS_PLANNINGS_LIST = 'orders-plannings/SET_ORDERS_PLANNINGS_LIST';
export const setOrdersPlanningsListAction = payload => ({
	type: SET_ORDERS_PLANNINGS_LIST,
	payload,
});

export const SET_IS_ORDERS_PLANNINGS_LIST_LOADING = 'orders-plannings/SET_IS_ORDERS_PLANNINGS_LIST_LOADING';
export const setIsOrdersPlanningsListLoadingAction = payload => ({
	type: SET_IS_ORDERS_PLANNINGS_LIST_LOADING,
	payload,
});

export const GET_GROUPS = 'orders-plannings/GET_GROUPS';
export const getGroupsAction = payload => ({
	type: GET_GROUPS,
	payload,
});

export const SET_GROUPS = 'orders-plannings/SET_GROUPS';
export const setGroupsAction = payload => ({
	type: SET_GROUPS,
	payload,
});

export const SET_IS_GROUPS_LOADING = 'orders-plannings/SET_IS_GROUPS_LOADING';
export const setIsGroupsLoadingAction = payload => ({
	type: SET_IS_GROUPS_LOADING,
	payload,
});

export const GET_CONFIGS = 'orders-plannings/GET_CONFIGS';
export const getConfigsAction = payload => ({
	type: GET_CONFIGS,
	payload,
});

export const SET_CONFIGS = 'orders-plannings/SET_CONFIGS';
export const setConfigsAction = payload => ({
	type: SET_CONFIGS,
	payload,
});

export const SET_IS_CONFIGS_LOADING = 'orders-plannings/SET_IS_CONFIGS_LOADING';
export const setIsConfigsLoadingAction = payload => ({
	type: SET_IS_CONFIGS_LOADING,
	payload,
});

export const SET_PAGINATION = 'orders-plannings/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'orders-plannings/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
